import { useQuery } from '@tanstack/react-query';
import { useResource } from 'datx-jsonapi-react';
import { useRouter } from 'next/router';
import { FC, Fragment, ReactNode, useMemo } from 'react';

import { NonPublicTicketCheck } from '@/components/ui/shared/overlays/NoTicketCheck/components/NonPublicTicketCheck';
import { NAVIGATION_ITEMS } from '@/constants/event-app-navigation-items';
import { queryThinEvent } from '@/queries/thin-events';
import { eventConfigurationQueryOptions } from '@/queries/upgrade/eventConfiguration';

import { NoTicketLoader } from './components/NoTicketLoader';
import { NoTicketSkeleton } from './components/NoTicketSkeleton';
import { checkIsEventPagePublic } from './NoTicketCheck.utils';

interface INoTicketCheckProps {
  eventId: string;
  children?: ReactNode;
}

export const NoTicketCheck: FC<INoTicketCheckProps> = ({ eventId, children }) => {
  const router = useRouter();

  const { data: event, error: eventError } = useResource(queryThinEvent(eventId));

  const { data: eventConfiguration, isLoading: isConfigurationLoading } = useQuery(
    eventConfigurationQueryOptions(eventId)
  );

  const isPublic = useMemo(
    () => eventConfiguration && checkIsEventPagePublic(NAVIGATION_ITEMS, router.asPath, eventConfiguration),
    [router, eventConfiguration]
  );

  if (!event && !eventError) return <NoTicketLoader />;

  if (isConfigurationLoading) return <NoTicketSkeleton />;

  if (isPublic) return <Fragment>{children}</Fragment>;

  return <NonPublicTicketCheck event={event}>{children}</NonPublicTicketCheck>;
};
